export default __webpack_public_path__ + "static/media/branding-logo.2446636b.svg";